import { Environment } from '@thiememeulenhoff/types';
import { OneGateEnvironmentType } from './environment.type';

export const environment: OneGateEnvironmentType = {
  environment: Environment.Staging,
  production: false,
  backendUrl: 'https://stag.onegate.thiememeulenhoff.nl/api/',
  editionFallbackUrl: 'https://stag.edition.thiememeulenhoff.nl/secure/next',
};
